import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const AddToSupplyChainButton = ({ disabled, onClick }) => {
  const { t } = useTranslation();
  return (
    <Button
      disabled={disabled}
      sx={{
        textTransform: "none",
        fontFamily: "Poppins",
        fontSize: 16,
        backgroundColor: "#4CAF50",
        color: "white",
        paddingX: 2,
        paddingY: 1,
        borderRadius: 3,
        "&:hover": {
          backgroundColor: "#43A047",
        },
        "&.Mui-disabled": {
          backgroundColor: "#C8E6C9",
          color: "#9E9E9E",
        },
      }}
      onClick={onClick}>
      {t("Add to Supply Chain")}
    </Button>
  );
};
export default AddToSupplyChainButton;
